<template>
    <section class="w-full mb-16 max-w-465 md:mb-30">

        <!--tabs-->
        <div class="flex">
            <a @click="toggleTab('chart')" :class="{ 'datepicker-active': isDatePickerActive, 'active': isChartActive }" class="flex items-center tab tab-datepicker">
                <span>{{ selectedDate.name }}</span>
                <svg xmlns="http://www.w3.org/2000/svg" width="8.643" height="8.642" viewBox="0 0 8.643 8.642" class="ml-8">
                    <path d="M8.474,2.828l.465,6.111L2.828,8.474Z" transform="translate(4.321 -4) rotate(45)" fill="#fff"/>
                </svg>
            </a>
            <a v-if="canUpdate && showTargets" @click="toggleTab('targets')" :class="{ 'active': isTargetsActive }" class="tab">Targets</a>
            <a v-if="canUpdate" @click="toggleTab('admin')" :class="{ 'active': isAdminActive }" class="tab">Admin</a>
        </div>

        <!--panels-->
        <div class="relative w-full border-t-2 bg-blue border-pink">

            <!--date picker-->
            <div :class="{ 'active': isDatePickerActive }" class="datepicker">
                <div>
                    <ul>
                        <li v-for="date in chart.date_options" :key="date.name">
                            <a @click="onSelectDate(date)" :class="{ active: selectedDate === date}">{{ date.name }}</a>
                        </li>
                    </ul>
                </div>
            </div>

            <panel-transition>
                <keep-alive>
                    <admin-update v-if="isAdminActive" v-model="chart" @updated="onUpdatedAdmin" @cancel="onCancelAdmin" class="panel active"></admin-update>
                    <targets v-else-if="isTargetsActive" v-model="chart" class="panel active" @updated="onUpdatedTarget"></targets>
                    <chart-card v-else v-model="chart" class="panel active"></chart-card>
                </keep-alive>
            </panel-transition>
        </div>
    </section>
</template>

<script>
    import AdminUpdate from "./panel/adminUpdate"
    import ChartPanel from "./panel/chartCard"
    import PanelTransition from "../../components/transitions/panelTransition"
    import Targets from "./panel/targets/targets"

    export default {
        props: {
            canUpdate: {
                type: Boolean,
                default: false
            },

            value: {
                type: Object,
                required: true,
            },
        },

        components: {
            AdminUpdate,
            ChartPanel,
            PanelTransition,
            Targets,
        },

        data() {
            return {
                chart: this.value,
                isDatePickerActive: false,
                selectedDate: {
                    month: null,
                    name: null,
                    year: null,
                },
                tabActive: 'chart',
            }
        },

        computed: {
            isAdminActive() {
                return this.tabActive === 'admin'
            },

            isChartActive() {
                return this.tabActive === 'chart'
            },

            isTargetsActive() {
                return this.tabActive === 'targets'
            },

            showTargets() {
                if (this.chart.is_split_column_by) {
                    return false
                }

                return !['bar-stacked', 'table'].includes(this.chart.type.slug)
            },

            startDate() {
                if (!this.selectedDate.month || !this.selectedDate.year) {
                    return null
                }

                return `${this.selectedDate.year}-${this.selectedDate.month}`
            },
        },

        mounted() {
            this.selectedDate = this.chart.date_options[0]
        },

        methods: {
            onCancelAdmin() {
                this.toggleTab('chart')
            },

            onSelectDate(date) {
                this.setDate(date)
                this.toggleDatePicker()
            },

            onUpdatedAdmin(chart) {
                this.chart = chart
                this.setDate(this.chart.date_options[0])
                this.$emit('input', chart)
                this.toggleTab('chart')
            },

            onUpdatedTarget(chart) {
                this.chart = chart
                this.$set(this.chart, 'datasets', chart.datasets)
                this.$set(this.chart, 'last_updated', new Date())
                this.$emit('input', chart)
            },

            setDate(date) {
                this.selectedDate = date
                this.$set(this.chart, 'start_date', this.startDate)
            },

            toggleDatePicker() {
                this.isDatePickerActive = !this.isDatePickerActive
            },

            toggleTab(tab) {
                if (tab === 'chart' && this.tabActive === tab) {
                    this.toggleDatePicker()
                } else if (this.isDatePickerActive) {
                    this.toggleDatePicker()
                }

                this.tabActive = tab
            }
        }
    }
</script>
